import React, { useCallback } from 'react'

import { AppSvg, Button, FormattedHTMLMessage, newIcons } from '@web/walter-ui-kit'
import { useNavigate } from 'react-router-dom'
import s from './s.module.css'
import { lang } from './lang'
import ModalView from '~components/ModalView'
import { generateQuery } from '~utils/generateQuery'
import { SettingsTabs } from '~modals/SettingsModal/Menu/const'

interface Props {
    onClose: () => void
}

function Content({ onClose }: Props) {
    const navigate = useNavigate()

    const onClick = useCallback(() => {
        navigate({
            search: generateQuery({ settings: SettingsTabs.identity }),
        })
        onClose()
    }, [navigate, onClose])

    return (
        <ModalView
            img={
                <div className={s.icon}>
                    <AppSvg svgName={newIcons.ic80Security} size={80} path="new-icons" />
                </div>
            }
            title={<FormattedHTMLMessage {...lang.title} />}
            subtitle={<FormattedHTMLMessage {...lang.subtitle} />}
            dataPointer="kyc_modal"
        >
            <Button dataPointer="verify_now" mode="primary" size="l" onClick={onClick} fullWidth>
                <FormattedHTMLMessage {...lang.button} />
            </Button>
        </ModalView>
    )
}

export default Content
